module.exports = __webpack_public_path__ + "fonts/roboto-v15-latin-regular.16e1d930cf13fb7a956372044b6d02d0.woff?";


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.woff
// module id = 914
// module chunks = 6